<template>
    <section class="sectionBackGround">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 text-left pt-lg" style="margin-top: 10%;">
                    <card gradient="secondary" shadow body-classes="p-lg-8">
                        <h4 class="mb-1 hi">Hi,</h4>
                        <p class="wz">欢迎来到 AnthroMindXX，一个关于健康饮食的个人网站。</p>
                        <p class="wz">在这里您将获得精心整理的文献资料，帮您从饮食方面解锁健康新状态。</p>
                        <p class="wz">网站目前在进行小范围内测，还未对外开放，更多信息可以在我微博主页了解。</p>
                        <p class="wz">微博 ID：AnthroMindXX</p>
                    </card>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
export default {
    name: "home",
    components: {}
};
</script>
<style scoped>
.sectionBackGround {
    /* 使内容区域填充剩余空间 */
    min-height: calc(100vh - 48px);
    /* 确保内容区域至少与视口高度减去头部高度一样大 */
    background-image: url('https://anthromindxx.com/ant/BK.png');
    /* 设置背景图路径 */
    background-position: center center;
    /* 背景图片位置 */
    background-attachment: fixed;
    /* 背景图片相对于视口固定 */
    background-size: 100% 100%;
    /* 背景图片根据元素大小缩放 */
    overflow-y: auto;
    /* 在内容较多时显示滚动条 */
}

.hi {
    color: #0FF5C8;
    font-family: 'Noto Sans S Chinese';
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
}

.wz {
    color: #333;
    font-family: 'Noto Sans S Chinese';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
}
</style>
